<template>
  <form @submit.prevent="submit">
    <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 4 из 6</span></h2>
    <h3 class="form__subtitle">Изменение E-mail</h3>
    <div class="form__description form__description_align-center">
      <p>Вы указали почту <strong>{{ emailOld }}</strong>. Если это не&nbsp;ваш адрес электронной почты, введите действующий адрес.</p>
    </div>
    <div class="form-row form-row_no-flex">
      <text-input
        label="E-mail"
        name="email"
        autocomplete="off"
        v-model="$v.form.email.$model"
        :error="$v.form.email.$error || errorEmailUsed()"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.email.$error || errorEmailUsed()">
            <div v-if="!$v.form.email.required">Заполните поле</div>
            <div v-else-if="!$v.form.email.email">Неправильная электронная почта</div>
            <div v-else-if="errorEmailUsed()">Эта электронная почта уже используется. Укажите другой адрес электронной почты или попробуйте восстановить пароль.</div>
          </div>
        </template>
      </text-input>
    </div>
    <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
      <template #errors>
        <div class="text-input__error">
          <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
        </div>
      </template>
    </smart-captcha>
    <div class="form-row form-row_mobile-wrap">
      <div class="form__nav">
        <router-link v-if="!$store.state.currentUser" :to="{name: 'login'}" class="form__link">Войти</router-link>
        <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
        <delete-questionnaire-btn />
      </div>
      <button class="form__submit button button__lg button__blue" type="submit">Продолжить</button>
    </div>
  </form>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import TextInput from './TextInput';
import api from "../services/api";
import SmartCaptcha from "./SmartCaptcha.vue";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

export default {
  name: "SignUpStepEmail",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    TextInput,
  },
  data() {
    return {
      form: {
        email: '',
        captcha: '',
      },
    };
  },
  props: {
    emailOld: {
      type: String,
    }
  },
  validations() {
    const form = {
      email: {required, email},
      captcha: {required},
    }
    return { form };
  },
  methods: {
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          const result = await api.registerStepEmail(this.form);

          if (result) {
            this.$emit('complete', this.form.email);
            this.$store.dispatch('hideErrorsBag');
          }
        } catch (e) {
          this.$store.dispatch('setErrors', e);
          await this.updateCaptchaOnError();
        } finally {
          this.$store.dispatch('hideLoader');
        }
      }
    },
    errorEmailUsed() {
      return this.$store.state.errors.find((item) => item === 'Email already used');
    }
  }
}
</script>
